import {Card, CardGroup, CardImg, CardDeck, Container, Col, Row, ListGroup, ListGroupItem} from 'react-bootstrap';
import OpenSourceBank from './images/OpenSourceBank.png';
import restaurantpic from './images/restaurantpic.png';
import astroHome from './images/astronaut_home.png';
import astroCards from './images/astronaut_cards.png';
import textToHTMLHome from './images/textToHTMLHome.png';
import textToHTMLSherlock from './images/textToHTMLSherlock.png';
export default function Projects(){
    return (
        <>
        <Container style={{justifyContent:"center"}}>
        <Row>
        <Col>
        <Card border="dark" style={{marginTop:'20px', marginBottom:"20px", width:"80%", color:"#B14AED"}}>
        <Card.Body>
            <Card.Text>
                <h6>Projects</h6>
                <hr/>
                <br></br>
                This page is intended to provide information on professional and personal development projects.
                <br></br>
                <br></br>
                I would like to think of this Portfolio website as a project, because I learned a lot about React and React Routing with Bootstrap.
            </Card.Text>
            
        </Card.Body>
        </Card>
        
        <br/>
        
        {/* Card 1 */}       
        <Card border="dark" style={{width:"80%",marginBottom: "20px"}}>        
        <Card.Header style={{color: "white", backgroundColor: "#042A2B"}} as="h6">Space Hub</Card.Header>       
        <Card.Img src={astroHome} />
        <br/>
        <Card.Img src={astroCards} />
            <Card.Body>
            <Card.Text style={{color:"#B14AED"}}>
                A personal hobby project about space news and astronauts. It was created between semesters with my friend and peer Kevan Yang.
            </Card.Text>
            <Card.Header style={{backgroundColor: "#042A2B", color: "white"}}>
                    Technologies Used:
                </Card.Header>
                    <ListGroupItem>HTML</ListGroupItem>
                    <ListGroupItem>CSS</ListGroupItem>
                    <ListGroupItem>TypeScript</ListGroupItem>
                    <ListGroupItem>Angular</ListGroupItem>
                    <ListGroupItem>Responsive Design</ListGroupItem>
            </Card.Body>
            <Card.Footer style={{backgroundColor:"white"}} className="text-center">
            <Card.Link href="https://space-hub-ca.netlify.app/" target="_blank">Website Link</Card.Link>
            <Card.Link href="https://github.com/AndreWillomitzer/Space-Hub">Github Source</Card.Link>

            </Card.Footer>      
        </Card>
        {/* Card 1 End*/}
        {/* Card 2 */}
        <Card border="dark" style={{width:"80%"}}>
        <Card.Header style={{color: "white", backgroundColor: "#042A2B"}} as="h6">textToHTML Static Site Generator</Card.Header>
        
        <Card.Img src={textToHTMLHome} />
        <br/>
        <Card.Img src={textToHTMLSherlock} />
            <Card.Body>
            <Card.Text style={{color:"#B14AED"}}>
                An open source command line tool I created to generate HTML files from txt and markdown files. Allows passing of optional parameters such as:
                <ul>
                <li>-h --help to display a list of commands available and common errors.</li>
                <li>-v --version to display tool release version.</li>
                <li>-o --output to specify outputting HTML files to a different directory.</li>
                <li>-s --stylesheet allows the user to specify a stylesheet link to use in the HTML files.</li>
                <li>-c --config allows for passing of the options via JSON config file.</li>
                </ul>
            </Card.Text>
            <Card.Header style={{backgroundColor: "#042A2B", color: "white"}}>
                    Technologies Used:
                </Card.Header>
                    <ListGroupItem>JavaScript</ListGroupItem>
                    <ListGroupItem>NodeJS</ListGroupItem>
                    <ListGroupItem>npm</ListGroupItem>
                    <ListGroupItem>Yargs</ListGroupItem>
            </Card.Body>
            <Card.Footer style={{backgroundColor:"white"}} className="text-center">

            <Card.Link href="https://texttohtml.netlify.app/">Website Link</Card.Link>
            <Card.Link href="https://github.com/AndreWillomitzer/textToHTML_V2">Github Source</Card.Link>
            </Card.Footer>
        </Card>
        <br/>
        {/* Card 2 End */}
        {/*Card 4 Start*/}
        <Card style={{width:"80%", marginBottom: "25px"}} border="dark">
        <Card.Header style={{color: "white", backgroundColor: "#042A2B"}} as="h6">Restaurant API Using Jquery and Lodash Templating</Card.Header>
        
        <Card.Img src={restaurantpic} />
        
            <Card.Body>
            <Card.Text style={{color:"#B14AED"}}>
                This JQuery/Lodash front end application uses a custom built web API hosted on Heroku that uses Express/NodeJS/MongoDB to fetch data from the MongoDB Restaurants Sample Data.
            </Card.Text>
            <Card.Header style={{backgroundColor: "#042A2B", color: "white"}}>
                    Technologies Used:
                </Card.Header>
                <ListGroup>
                    <ListGroupItem>HTML</ListGroupItem>
                    <ListGroupItem>CSS</ListGroupItem>
                    <ListGroupItem>JavaScript</ListGroupItem>
                    <ListGroupItem>JQuery</ListGroupItem>
                    <ListGroupItem>Bootstrap</ListGroupItem>
                    <ListGroupItem>Lodash</ListGroupItem>
                    <ListGroupItem>MongoDB</ListGroupItem>
                </ListGroup>
            </Card.Body>
            <Card.Footer style={{backgroundColor:"white"}} className="text-center">

            <Card.Link href="https://gallant-nobel-86b853.netlify.app/" target="_blank">Website Link</Card.Link>
            <Card.Link href="https://github.com/AndreWillomitzer/Restaurant-App-Using-Custom-API" target="_blank">Github Source</Card.Link>
            </Card.Footer>
        </Card>
        {/*Card 4 End*/}
        
        </Col>
        </Row>
        
        </Container>
        </>
    );
}
